export default {"src":"/_next/static/media/frontpage_hero.71f56419.svg","height":830,"width":831};